export const defaultBikeFleetQuery = {
	status: 1,
}

export const SUCCESS = "success"
export const ERROR = "error"

export const ACCEPTED_BIKE_FLEET = 0
export const REFUSED_BIKE_FLEET = 1

export const fleetManagementChoice = [
	{ id: ACCEPTED_BIKE_FLEET, value: ACCEPTED_BIKE_FLEET, label: "bikeFleet.form.hasBikeFLeet" },
	{ id: REFUSED_BIKE_FLEET, value: REFUSED_BIKE_FLEET, label: "bikeFleet.form.noBikeFleet" },
]

export enum ChainLabelEnum {
	LECLERC = "LECL",
	EASYCASH = "EACA",
	CASHCONVERTER = "CACO",
	GIANSTORE = "GIAN",
	YAMAHA = "YAMA",
}
